
import _ from 'lodash'
import Hr from '~/components/reusables/hr/Hr.vue'
import FontPicker from '~/components/fontPicker/FontPicker.vue'
import { BrandingStructure } from '~/mixins/BrandingStructure.js'
import { headerTexts } from '~/mixins/headerTexts.js'

export default {
  name: 'EditUI',
  mixins: [BrandingStructure, headerTexts],
  props: {
    top: {},
    left: {},
    right: {},
    bottom: {},
    title: {},
    isBackgroundImage: {
      type: Boolean,
      default: false,
    },
    sectionName: {
      type: String,
      default: '',
    },
    captionVisibilityTexts: {
      type: String,
      default: '',
    },
    bindedSubheader: {
      type: String,
      default: '',
    },
    bindedHeader: {
      type: String,
      default: '',
    },
    section: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      localBrandingSettings: null,
      settingsVersion: 0,
      // Paths (dot notation) the user actually edited in this popover session.
      // Update sends ONLY these as a minimal diff: sending the whole cloned doc
      // re-submitted stale values (the iframe snapshot lags one save behind the
      // admin DB) and silently reverted the previous save (Asana 1216390631315123).
      changedPaths: [],
      controls: [
        {
          showIf: ['textColor'],
          component: 'ColorPicker',
          props: { label: 'Text Color' },
          model: 'colors.trustCenterLogoColor',
        },

        {
          showIf: ['textColor'],
          component: 'ColorPicker',
          props: { label: 'Separator Color' },
          model: 'colors.trustCenterSeparatorColor',
        },

        {
          showIf: ['product'],
          component: 'el-switch',
          props: {
            class: 'mb-10 mt-10  pl-10 pr-10',
            'inactive-text': `Show 'Overall' option`,
            'active-text': 'Hide',
          },
          model: `products.showOverall`,
        },
        {
          showIf: ['textColor'],
          component: 'el-switch',
          props: {
            class: 'mb-10  pl-10 pr-10',
            'inactive-text': 'Show separator',
            'active-text': 'Hide',
          },
          model: `textsVisibility.hideTrustCenterSeparator`,
        },
        {
          showIf: ['textColor'],
          component: 'el-switch',
          props: {
            class: 'mb-10  pl-10 pr-10',
            'inactive-text': `Show 'Trust Center' text`,
            'active-text': 'Hide',
          },
          model: `textsVisibility.hideTrustCenterText`,
        },

        {
          showIf: ['backgroundColor'],
          component: 'ColorPicker',
          props: { label: 'Background Color' },
          model: 'navbarBg',
        },
        {
          showIf: ['activeLinkColor'],
          component: 'ColorPicker',
          props: { label: 'Link Color' },
          model: 'sidebarLinkColor',
        },

        {
          showIf: ['activeLinkColor'],
          component: 'ColorPicker',
          props: { label: 'Active Link Color' },
          model: 'sidebarLinkActiveColor',
        },
        {
          showIf: ['groupsColor', 'groupsColorOverview', 'groupsColorControls'],
          component: 'ColorPicker',
          props: { label: 'Link Color' },
          model:
            this.sectionName === 'groupsColorOverview'
              ? 'groupColorOverview'
              : this.sectionName === 'groupsColorControls'
              ? 'groupColorControls'
              : 'groupColor',
        },
        {
          showIf: ['groupsColor', 'groupsColorOverview', 'groupsColorControls'],
          component: 'ColorPicker',
          props: { label: 'Active Link Color' },
          model:
            this.sectionName === 'groupsColorOverview'
              ? 'groupActiveColorOverview'
              : this.sectionName === 'groupsColorControls'
              ? 'groupActiveColorControls'
              : 'groupActiveColorDocuments',
        },
        {
          showIf: ['placeholder'],
          component: 'PlaceHolderInput',
          props: { label: 'Placeholder' },
          model: 'mainInputPlaceholder',
        },
        {
          showIf: ['product'],
          component: 'PlaceHolderInput',
          props: { label: `'Overall' Text` },
          model: 'products.textOverall',
        },
        {
          showIf: ['placeholder'],
          component: 'ColorPicker',
          props: { label: 'Placeholder Color' },
          model: 'mainInputPlaceholderColor',
        },
        {
          showIf: ['placeholder'],
          component: 'ColorPicker',
          props: { label: 'Icon Color' },
          model: 'mainInputPlaceholderIconColor',
        },
        {
          showIf: ['placeholder'],
          component: 'ColorPicker',
          props: { label: 'Border Color' },
          model: 'mainInputPlaceholderBorderColor',
        },

        {
          showIf: ['buttons'],
          text: 'Note this will apply to all buttons.',
          props: { class: 'pt-10 pl-10 pr-10 font-size-12' },
        },
        {
          showIf: ['buttons'],
          component: 'ColorPicker',
          props: { label: 'Background Color' },
          model: 'colors.buttonColor',
        },
        {
          showIf: ['buttons'],
          component: 'ColorPicker',
          props: { label: 'Border Color' },
          model: 'colors.buttonBorderColor',
        },
        {
          showIf: ['buttons'],
          component: 'ColorPicker',
          props: { label: 'Text Color' },
          model: 'colors.buttonColorText',
        },
        {
          showIf: ['overviewHeaderEdit'],
          component: 'el-switch',
          props: {
            class: 'mb-10  pl-10 pr-10',
            'inactive-text': 'Show header',
            'active-text': 'Hide',
          },
          model: (vm) => `textsVisibility.${vm.bindedHeader}`,
        },

        {
          showIf: ['overviewHeaderEdit'],
          component: 'el-switch',
          props: {
            class: 'mb-20 pl-10 pr-10',
            'inactive-text': 'Show caption',
            'active-text': 'Hide',
          },
          model: (vm) => `textsVisibility.${vm.captionVisibilityTexts}`,
        },
        {
          showIf: ['overviewHeaderEdit'],
          component: 'PlaceHolderInput',
          props: {
            label: 'Header',
            placeholder: (vm) =>
              vm.bindedHeader
                ? vm.getDefaultTextByHeaderKey(vm.bindedHeader)
                : '',
          },
          model: (vm) =>
            vm.bindedHeader ? `overview.${vm.bindedHeader}` : 'overview.header',
          placeholder: (vm) =>
            vm.bindedHeader
              ? vm.getDefaultTextByHeaderKey(vm.bindedHeader)
              : '',
        },

        {
          showIf: ['overviewHeaderEdit'],
          component: 'PlaceHolderInput',
          props: {
            label: 'Caption',
          },
          model: (vm) => `overview.${vm.bindedSubheader}`,
          placeholder: (vm) =>
            vm.getDefaultTextBySubheaderKey(vm.bindedSubheader),
        },
        {
          showIf: ['overviewHeaderEdit'],
          component: 'ColorPicker',
          props: { label: 'Header Font Color' },
          model: (vm) =>
            vm.section
              ? `overview.${vm.section}HeaderColor`
              : 'overview.headersFontColor',
        },
        {
          showIf: ['overviewHeaderEdit'],
          component: 'ColorPicker',
          props: { label: 'Caption Font Color' },
          model: (vm) =>
            vm.section
              ? `overview.${vm.section}CaptionColor`
              : 'overview.captionFontColor',
        },
        {
          showIf: ['overviewHeaderEdit'],
          component: 'FontSize',
          props: { label: 'Header Font Size' },
          model: (vm) =>
            vm.section
              ? `overview.${vm.section}HeaderFontSize`
              : 'overview.headersFontSize',
        },
        {
          showIf: ['controlTitlePage'],
          component: 'FontSize',
          props: { label: 'Header Font Size' },
          model: 'controlTitlePageFontSize',
        },
        {
          showIf: ['controlTitlePage'],
          component: 'FontSize',
          props: { label: 'Caption Font Size' },
          model: 'controlPageCaptionFontSize',
        },
        {
          showIf: ['controlTitlePage'],
          component: 'ColorPicker',
          props: { label: 'Header Color' },
          model: 'controlTitlePageColor',
        },
        {
          showIf: ['controlTitlePage'],
          component: 'ColorPicker',
          props: { label: 'Caption Color' },
          model: 'controlPageCaptionColor',
        },

        {
          showIf: ['overviewHeaderEdit'],
          component: 'FontSize',
          props: { label: 'Caption Font Size' },
          model: (vm) =>
            vm.section
              ? `overview.${vm.section}CaptionFontSize`
              : 'overview.captionFontSize',
        },
        {
          showIf: ['overviewHeaderEdit'],
          component: 'AlignmentSelect',
          props: {
            label: 'Alignment',
            placeholder: 'Select alignment',
          },
          model: (vm) => `overview.${vm.section}Alignment`,
          condition: (vm) => vm.section === 'overviewContainerFirstSection',
        },
        {
          showIf: ['documentTitle'],
          component: 'FontSize',
          props: { label: 'Font Size' },
          model: (vm) =>
            vm.section === 'docCardNewOverview'
              ? 'documentTitleOverviewFontSize'
              : 'documentTitleFontSize',
          condition: (vm) =>
            vm.section === 'docCardNew' || vm.section === 'docCardNewOverview',
        },

        {
          showIf: ['controlTitle'],
          component: 'FontSize',
          props: { label: 'Header Font Size' },
          model: 'controlTitleFontSize',
          condition: (vm) => vm.section === 'controlCardNew',
        },
        {
          showIf: ['compliancePage'],
          component: 'FontSize',
          props: { label: 'Header Font Size' },
          model: 'complianceHeaderPageFontSize',
          condition: (vm) => vm.section === 'complianceCardNew',
        },
        {
          showIf: ['customersPage'],
          component: 'FontSize',
          props: { label: 'Header Font Size' },
          model: 'customersHeaderPageFontSize',
          condition: (vm) => vm.section === 'customersCardNew',
        },
        {
          showIf: ['teamPage'],
          component: 'FontSize',
          props: { label: 'Header Font Size' },
          model: 'teamHeaderPageFontSize',
          condition: (vm) => vm.section === 'teamCardNew',
        },
        {
          showIf: ['subprocessorsPage'],
          component: 'FontSize',
          props: { label: 'Header Font Size' },
          model: 'subprocessorsHeaderPageFontSize',
          condition: (vm) => vm.section === 'subprocessorsCardNew',
        },

        {
          showIf: ['updatesCardTitle'],
          component: 'FontSize',
          props: { label: 'Header Font Size' },
          model: (vm) =>
            vm.section === 'updatesCard'
              ? 'updateTitleFontSize'
              : 'updateTitleFontSizeNew',
          condition: (vm) =>
            vm.section === 'updatesCard' || vm.section === 'updatesCardNew',
        },

        {
          showIf: ['documentTitle'],
          component: 'ColorPicker',
          props: { label: 'Color' },
          model: (vm) =>
            vm.section === 'docCardNewOverview'
              ? 'documentTitleOverviewColor'
              : 'documentTitleColor',
          condition: (vm) =>
            vm.section === 'docCardNew' || vm.section === 'docCardNewOverview',
        },

        {
          showIf: ['documentTitle'],
          component: 'FontSize',
          props: { label: 'Font Size' },
          model: (vm) =>
            vm.section === 'securityConfig'
              ? 'securityConfigFontSize'
              : 'securityConfigFontSizeNew',
          condition: (vm) =>
            vm.section === 'securityConfig' ||
            vm.section === 'securityConfigNew',
        },
        {
          showIf: ['controlTitle'],
          component: 'FontSize',
          props: { label: 'Caption Font Size' },
          model: 'controlTitleCaptionFontSize',
          condition: (vm) => vm.section === 'controlCardNew',
        },
        {
          showIf: ['compliancePage'],
          component: 'FontSize',
          props: { label: 'Caption Font Size' },
          model: 'complianceCaptionFontSize',
          condition: (vm) => vm.section === 'complianceCardNew',
        },
        {
          showIf: ['customersPage'],
          component: 'FontSize',
          props: { label: 'Caption Font Size' },
          model: 'customersCaptionFontSize',
          condition: (vm) => vm.section === 'customersCardNew',
        },
        {
          showIf: ['teamPage'],
          component: 'FontSize',
          props: { label: 'Caption Font Size' },
          model: 'teamCaptionFontSize',
          condition: (vm) => vm.section === 'teamCardNew',
        },
        {
          showIf: ['subprocessorsPage'],
          component: 'FontSize',
          props: { label: 'Caption Font Size' },
          model: 'subprocessorsCaptionFontSize',
          condition: (vm) => vm.section === 'subprocessorsCardNew',
        },
        {
          showIf: ['updatesCardTitle'],
          component: 'FontSize',
          props: { label: 'Caption Font Size' },
          model: (vm) =>
            vm.section === 'updatesCard'
              ? 'updateTitleCaptionFontSize'
              : 'updateTitleCaptionFontSizeNew',
          condition: (vm) =>
            vm.section === 'updatesCard' || vm.section === 'updatesCardNew',
        },
        {
          showIf: ['updatesCardTitle'],
          component: 'FontSize',
          props: { label: 'Date Font Size' },
          model: (vm) =>
            vm.section === 'updatesCard'
              ? 'updateTitleDateFontSize'
              : 'updateTitleDateFontSizeNew',
          condition: (vm) =>
            vm.section === 'updatesCard' || vm.section === 'updatesCardNew',
        },
        {
          showIf: ['controlTitle'],
          component: 'ColorPicker',
          props: { label: 'Link Color' },
          model: 'controlTitleLinkColor',
          condition: (vm) => vm.section === 'controlCardNew',
        },
        {
          showIf: ['updatesCardTitle'],
          component: 'ColorPicker',
          props: { label: 'Link Color' },
          model: (vm) =>
            vm.section === 'updatesCard'
              ? 'updateTitleLinkColor'
              : 'updateTitleLinkColorNew',
          condition: (vm) =>
            vm.section === 'updatesCard' || vm.section === 'updatesCardNew',
        },
        {
          showIf: ['updatesCardTitle'],
          component: 'ColorPicker',
          props: { label: 'Date Color' },
          model: (vm) =>
            vm.section === 'updatesCard'
              ? 'updateTitleDateColor'
              : 'updateTitleDateColorNew',
          condition: (vm) =>
            vm.section === 'updatesCard' || vm.section === 'updatesCardNew',
        },
        {
          showIf: ['documentTitle'],
          component: 'ColorPicker',
          props: { label: 'Color' },
          model: (vm) =>
            vm.section === 'securityConfig'
              ? 'securityConfigColor'
              : 'securityConfigColorNew',
          condition: (vm) =>
            vm.section === 'securityConfig' ||
            vm.section === 'securityConfigNew',
        },
        {
          showIf: ['controlTitle'],
          component: 'ColorPicker',
          props: { label: 'Header Color' },
          model: 'controlTitleColor',
          condition: (vm) => vm.section === 'controlCardNew',
        },
        {
          showIf: ['updatesCardTitle'],
          component: 'ColorPicker',
          props: { label: 'Header Color' },
          model: (vm) =>
            vm.section === 'updatesCard'
              ? 'updateTitleColor'
              : 'updateTitleColorNew',
          condition: (vm) =>
            vm.section === 'updatesCard' || vm.section === 'updatesCardNew',
        },
        {
          showIf: ['controlTitle'],
          component: 'ColorPicker',
          props: { label: 'Caption Color' },
          model: 'controlTitleCaptionColor',
          condition: (vm) => vm.section === 'controlCardNew',
        },
        {
          showIf: ['updatesCardTitle'],
          component: 'ColorPicker',
          props: { label: 'Caption Color' },
          model: (vm) =>
            vm.section === 'updatesCard'
              ? 'updateTitleCaptionColor'
              : 'updateTitleCaptionColorNew',
          condition: (vm) =>
            vm.section === 'updatesCard' || vm.section === 'updatesCardNew',
        },
        {
          showIf: ['global'],
          text: 'Note this will apply to all buttons and fonts.',
          props: { class: 'font-size-12 pl-10 pr-10 mt-10' },
        },
        {
          showIf: ['global'],
          component: 'ButtonsShape',
          props: { label: 'Button Shape' },
          model: 'buttonShape.shape',
        },
        {
          showIf: ['global'],
          component: 'TextFontPicker',
          props: { label: 'Application Font' },
          model: 'fonts.globalFont',
        },
        {
          showIf: ['global'],
          component: 'ColorPicker',
          props: { label: 'Application Color' },
          model: 'fonts.globalColor',
        },
        {
          showIf: ['global'],
          component: 'TextFontPicker',
          props: { label: 'Headers Font' },
          model: 'fonts.globalHeadersFont',
        },
        {
          showIf: ['global'],
          component: 'ColorPicker',
          props: { label: 'Headers Color' },
          model: 'fonts.globalHeadersColor',
        },
        {
          showIf: ['global'],
          component: 'FontWeight',
          props: { label: 'Headers Weight' },
          model: 'fonts.globalHeadersWeight',
        },
        {
          showIf: ['global'],
          component: 'TextFontPicker',
          props: { label: 'Paragraph Font' },
          model: 'fonts.paragraphsGlobalFont',
        },
        {
          showIf: ['global'],
          component: 'ColorPicker',
          props: { label: 'Paragraph Color' },
          model: 'fonts.paragraphsGlobalColor',
        },
        {
          // Custom title for the About card. When left empty the trust page
          // falls back to the default "About" / "About + name" wording.
          showIf: ['aboutCompany'],
          component: 'PlaceHolderInput',
          props: { label: 'Title' },
          model: 'overview.aboutCompanyTitle',
          placeholder: (vm) => vm.aboutCompanyDefaultTitle,
        },
        {
          showIf: [
            'sectionBgColor',
            'sectionBgColorWithFont',
            'sectionBgColorWithColor',
            'footerSectionBgColor',
            'aboutCompany',
            'certifications',
            'documentTitle',
            'controlTitle',
            'updatesCardTitle',
            'customersCard',
            'subprocessorsCard',
            'sectionBgColorWithBorder',
            'compliancePage',
            'customersPage',
            'subprocessorsPage',
            'teamPage',
          ],
          component: 'el-switch',
          props: {
            class: 'mb-20 pt-10 pl-10 pr-10',
            'active-text': 'Gradient',
            'inactive-text': 'Solid',
          },
          model: (vm) => `sectionsGradientBg.${vm.section}`,
        },
        {
          showIf: [
            'sectionBgColor',
            'sectionBgColorWithFont',
            'sectionBgColorWithColor',
            'footerSectionBgColor',
            'aboutCompany',
            'certifications',
            'documentTitle',
            'controlTitle',
            'updatesCardTitle',
            'customersCard',
            'subprocessorsCard',
            'sectionBgColorWithBorder',
            'compliancePage',
            'customersPage',
            'subprocessorsPage',
            'teamPage',
          ],
          component: 'ColorPicker',
          props: { label: 'Background Color' },
          model: (vm) => `sectionsBgColor.${vm.section}`,
          condition: (vm) => !vm.getValue(`sectionsGradientBg.${vm.section}`),
        },
        {
          showIf: [
            'certifications',
            'aboutCompany',
            'documentTitle',
            'controlTitle',
            'updatesCardTitle',
            'sectionBgColorWithFont',
            'customersCard',
            'subprocessorsCard',
            'compliancePage',
            'customersPage',
            'subprocessorsPage',
            'teamPage',
          ],
          component: 'ColorPicker',
          props: { label: 'Border Color' },
          model: (vm) => `bordersColor.${vm.section}`,
        },
        {
          showIf: [
            'sectionBgColor',
            'sectionBgColorWithFont',
            'sectionBgColorWithColor',
            'footerSectionBgColor',
            'aboutCompany',
            'certifications',
            'documentTitle',
            'controlTitle',
            'updatesCardTitle',
            'customersCard',
            'subprocessorsCard',
            'sectionBgColorWithBorder',
            'compliancePage',
            'customersPage',
            'subprocessorsPage',
            'teamPage',
          ],
          component: 'ColorPicker',
          props: { label: 'Background First Color' },
          model: (vm) => `sectionsBgColor.${vm.section}Gradient.firstColor`,
          condition: (vm) => vm.getValue(`sectionsGradientBg.${vm.section}`),
        },
        {
          showIf: [
            'sectionBgColor',
            'sectionBgColorWithFont',
            'sectionBgColorWithColor',
            'footerSectionBgColor',
            'aboutCompany',
            'certifications',
            'documentTitle',
            'controlTitle',
            'updatesCardTitle',
            'customersCard',
            'subprocessorsCard',
            'sectionBgColorWithBorder',
            'compliancePage',
            'customersPage',
            'subprocessorsPage',
            'teamPage',
          ],
          component: 'ColorPicker',
          props: { label: 'Background Second Color' },
          model: (vm) => `sectionsBgColor.${vm.section}Gradient.secondColor`,
          condition: (vm) => vm.getValue(`sectionsGradientBg.${vm.section}`),
        },
        {
          showIf: ['sectionBgColor'],
          component: 'AlignmentSelect',
          props: {
            label: 'Alignment',
            placeholder: 'Select alignment',
          },
          model: (vm) => `overview.${vm.section}Alignment`,
          condition: (vm) =>
            vm.section === 'customersSection' ||
            vm.section === 'subprocessorsSection',
        },
        {
          showIf: ['sectionBgColor', 'overviewHeaderEdit'],
          component: 'AlignmentSelect',
          props: {
            label: 'Section Separator',
            placeholder: 'Select position',
            options: [
              { label: 'Above', value: 'above' },
              { label: 'Below', value: 'below' },
              { label: 'Without separator', value: 'none' },
            ],
          },
          model: (vm) => `overview.${vm.getSeparatorConfigKey()}Separator`,
          condition: (vm) => Boolean(vm.getSeparatorConfigKey()),
        },
        {
          showIf: ['sectionBgColor'],
          text: 'Note: If you have 6 or more elements, we recommend switching the alignment to center to take the full width of the section.',
          props: {
            class: 'pt-10 pl-10 pr-10 font-size-12 italic default-styles',
          },
          condition: (vm) => {
            const section = vm.section
            return (
              section === 'customersSection' ||
              section === 'subprocessorsSection'
            )
          },
        },
        {
          showIf: ['sectionBgColorWithFont', 'aboutCompany', 'certifications'],
          component: 'FontSize',
          props: { label: 'Header Font Size' },
          model: (vm) => `overview.${vm.section}HeaderFontSize`,
        },
        {
          showIf: [
            'sectionBgColorWithFont',
            'sectionBgColorWithColor',
            'aboutCompany',
            'certifications',
            'compliancePage',
            'customersPage',
            'subprocessorsPage',
            'teamPage',
          ],
          component: 'ColorPicker',
          props: { label: 'Header Color' },
          model: (vm) => `overview.${vm.section}HeaderColor`,
        },
        {
          showIf: [
            'sectionBgColorWithFont',
            'aboutCompany',
            'certifications',
            'subprocessorsCard',
            'customersCard',
          ],
          component: 'FontSize',
          props: { label: 'Caption Font Size' },
          model: (vm) => `overview.${vm.section}CaptionFontSize`,
        },
        {
          showIf: [
            'sectionBgColorWithFont',
            'sectionBgColorWithColor',
            'aboutCompany',
            'certifications',
            'subprocessorsCard',
            'customersCard',
            'compliancePage',
            'customersPage',
            'subprocessorsPage',
            'teamPage',
          ],
          component: 'ColorPicker',
          props: { label: 'Caption Color' },
          model: (vm) => `overview.${vm.section}CaptionColor`,
        },
        {
          showIf: ['certifications', 'sectionBgColorWithFont'],
          component: 'ColorPicker',
          props: { label: 'Link Color' },
          model: 'seeMoreLinkColor',
        },
        {
          showIf: ['compliancePage'],
          component: 'ColorPicker',
          props: { label: 'Link Color' },
          model: 'complianceSeeMoreLinkColor',
        },
        {
          showIf: ['documentTitle'],
          component: 'ColorPicker',
          props: { label: 'Link Color' },
          model: 'documentSeeMoreLinkColor',
        },
        {
          showIf: ['customersPage'],
          component: 'ColorPicker',
          props: { label: 'Link Color' },
          model: 'customersSeeMoreLinkColor',
        },
        {
          showIf: ['teamPage'],
          component: 'ColorPicker',
          props: { label: 'Link Color' },
          model: 'teamSeeMoreLinkColor',
        },
        {
          showIf: ['subprocessorsPage'],
          component: 'ColorPicker',
          props: { label: 'Link Color' },
          model: 'subprocessorsSeeMoreLinkColor',
        },

        {
          showIf: ['sectionBgColorWithFont'],
          component: 'el-switch',
          props: {
            class: 'mb-10  pl-10 pr-10',
            'inactive-text': 'Black Icons',
            'active-text': 'White Icons',
          },
          model: (vm) => `dataTypesWhiteIcons`,
        },
        {
          showIf: [
            'documentTitle',
            'compliancePage',
            'customersPage',
            'subprocessorsPage',
            'teamPage',
          ],
          component: 'el-switch',
          props: {
            class: 'mb-10  pl-10 pr-10',
            'inactive-text': 'Black Icons',
            'active-text': 'White Icons',
          },
          model: (vm) => `docIconsColor${vm.section}`,
        },
        {
          showIf: ['buttons'],
          component: 'el-switch',
          props: {
            class: 'mb-10  pl-10 pr-10',
            'inactive-text': 'Black Icons',
            'active-text': 'White Icons',
          },
          model: (vm) => `buttonIconsColor`,
        },

        {
          showIf: ['userMenuIcons'],
          component: 'ColorPicker',
          props: { label: 'Subscribe Text Color' },
          model: 'userMenu.subscribeTextColor',
        },
        {
          showIf: ['userMenuIcons'],
          component: 'ColorPicker',
          props: { label: 'Icon Color' },
          model: 'userMenu.iconColor',
        },

        {
          showIf: ['sectionBgColorWithBorder'],
          component: 'ColorPicker',
          props: { label: 'Bottom border Color' },
          model: 'colors.bottomNavbarBgColor',
        },
        {
          showIf: ['logo'],
          component: 'LogoPicker',
          props: { label: 'Footer Logo Color' },
          model: 'footer.logoColor',
        },
        {
          showIf: ['logo'],
          component: 'ColorPicker',
          props: { label: 'Logo Text Color' },
          model: 'logoTextColor',
        },
        {
          showIf: ['logo'],
          component: 'ColorPicker',
          props: { label: 'Link Color' },
          model: 'logoLinkColor',
        },
        {
          showIf: ['documentTitle'],
          component: 'ColorPicker',
          props: { label: 'Link Color' },
          model: (vm) =>
            vm.section === 'securityConfig'
              ? 'securityConfigLinkColor'
              : 'securityConfigLinkColorNew',
          condition: (vm) =>
            vm.section === 'securityConfig' ||
            vm.section === 'securityConfigNew',
        },
        {
          showIf: ['global'],
          component: 'ColorPicker',
          props: { label: 'Checkbox Border Color' },
          model: 'documentCheckboxBorderColor',
        },
        {
          showIf: ['global'],
          component: 'ColorPicker',
          props: { label: 'Checkbox Background Color' },
          model: 'documentCheckboxBgColor',
        },
        {
          showIf: ['global'],
          component: 'ColorPicker',
          props: { label: 'Checkbox Check Color' },
          model: 'documentCheckboxCheckColor',
        },
        {
          // Documents layout: unset/false keeps the redesigned rows,
          // on = pre-redesign square cards (Asana 1216994315081349).
          showIf: ['global'],
          component: 'el-switch',
          props: {
            class: 'mb-10 mt-10 pl-10 pr-10',
            'inactive-text': 'Documents as rows',
            'active-text': 'Classic cards',
          },
          model: 'classicDocumentCards',
        },
      ],
    }
  },

  methods: {
    // Maps the `section` prop (which differs depending on where EditUi
    // is mounted - section-level wrapper vs NewPageHeader) to a single
    // canonical key used to persist/lookup the per-section separator setting.
    // Returns null when the current EditUi is not for an overview section.
    getSeparatorConfigKey() {
      const map = {
        overviewContainerFirstSection: 'overviewContainerFirstSection',
        overviewContainerSecondSection: 'overviewContainerSecondSection',
        overviewContainerControlsSection: 'overviewContainerControlsSection',
        overviewContainerThirdSection: 'overviewContainerThirdSection',
        customersSection: 'customersSection',
        subprocessorsSection: 'subprocessorsSection',
        updatesSection: 'updatesSection',
        securitySettingsSection: 'securitySettingsSection',
        securityLibrary: 'overviewContainerSecondSection',
        controls: 'overviewContainerControlsSection',
        dataTypes: 'overviewContainerThirdSection',
        customers: 'customersSection',
        subprocessors: 'subprocessorsSection',
        updates: 'updatesSection',
        securityConfig: 'securitySettingsSection',
      }
      return map[this.section] || null
    },
    getValue(model) {
      if (!model) return
      const path = typeof model === 'function' ? model(this) : model
      const value = _.get(this.brandingSettings, path)
      // console.log('getValue called:', {
      //   path,
      //   value,
      //   brandingSettings: this.brandingSettings,
      // })

      // For el-switch components, ensure we return a boolean
      if (path.includes('sectionsGradientBg')) {
        return Boolean(value)
      }

      return value
    },
    setValue(model, value) {
      if (!model) return
      const path = typeof model === 'function' ? model(this) : model

      // Initialize local settings if not already done
      if (!this.localBrandingSettings) {
        this.localBrandingSettings = this.brandingSettingsOriginal
      }

      if (!this.changedPaths.includes(path)) {
        this.changedPaths.push(path)
      }

      console.log('setValue called:', {
        path,
        value,
        currentValue: _.get(this.localBrandingSettings, path),
      })

      // Ensure boolean values are properly handled for el-switch
      if (path.includes('sectionsGradientBg')) {
        value = Boolean(value)
      } else if (value === null) {
        value = ''
      }

      // Use Vue.set for better reactivity with nested objects
      const pathArray = path.split('.')
      const lastKey = pathArray.pop()
      const parentPath = pathArray.join('.')

      if (pathArray.length > 0) {
        const parent = _.get(this.localBrandingSettings, parentPath)
        if (parent) {
          this.$set(parent, lastKey, value)
        } else {
          // Create the parent object if it doesn't exist
          _.set(this.localBrandingSettings, parentPath, {})
          this.$set(
            _.get(this.localBrandingSettings, parentPath),
            lastKey,
            value
          )
        }
      } else {
        this.$set(this.localBrandingSettings, lastKey, value)
      }

      // Increment version to trigger reactivity
      this.settingsVersion++

      console.log('After setValue:', {
        path,
        newValue: _.get(this.localBrandingSettings, path),
        settingsVersion: this.settingsVersion,
      })

      // Use nextTick to ensure DOM updates
      this.$nextTick(() => {
        console.log('After nextTick - value should be updated')
      })
    },
    closePopover() {
      // Reset local settings when closing without saving
      this.localBrandingSettings = null
      this.settingsVersion = 0
      this.changedPaths = []
      this.$refs['popover-edit-ui']?.doClose()
    },
    updateSettings() {
      // Build a minimal diff of only the paths edited in this popover session.
      // Sending the full cloned doc pushed stale values from the iframe snapshot
      // back over fresher DB data, reverting earlier saves (Asana 1216390631315123).
      let diff = {}
      this.changedPaths.forEach((path) => {
        _.set(diff, path, _.get(this.localBrandingSettings, path))
      })
      // removeEmpty keeps the historical payload shape: null/undefined values
      // and empty objects are dropped (empty strings and false still go through).
      let settings = this.removeEmpty(diff)
      console.log(
        'Inside updateSettings this.changedPaths, diff, settings',
        this.changedPaths,
        diff,
        settings
      )
      if (!_.isEmpty(settings)) {
        window.parent.postMessage(
          {
            type: 'TRUST_CENTER_UPDATED',
            payload: {
              changes: settings,
            },
          },
          '*'
        )
      }
      // Reset local settings after update
      this.localBrandingSettings = null
      this.settingsVersion = 0
      this.changedPaths = []
      this.$refs['popover-edit-ui']?.doClose()
    },
    removeEmpty(obj) {
      console.log('Inside removeEmpty obj', _.cloneDeep(obj))
      if (obj === null || obj === undefined || typeof obj !== 'object')
        return obj

      let res = Object.entries(obj).reduce((acc, [key, value]) => {
        const cleanedValue = this.removeEmpty(value)

        const isNotEmpty =
          cleanedValue != null &&
          cleanedValue != undefined &&
          !(
            typeof cleanedValue === 'object' &&
            Object.keys(cleanedValue).length === 0
          )

        if (isNotEmpty) {
          acc[key] = cleanedValue
        }
        // console.log('Inside removeEmpty key, value, cleanedValue,  acc[key]:', key, value, cleanedValue, _.get(acc, key))

        return acc
      }, {})
      console.log('Inside removeEmpty res', res)
      return res
    },
    handleSwitchChange(model, value) {
      console.log('handleSwitchChange called:', { model, value })

      // Initialize local settings if not already done
      if (!this.localBrandingSettings) {
        this.localBrandingSettings = this.brandingSettingsOriginal
      }

      const path = typeof model === 'function' ? model(this) : model
      console.log('Switch path:', path)

      if (!this.changedPaths.includes(path)) {
        this.changedPaths.push(path)
      }

      // Ensure boolean value
      const booleanValue = Boolean(value)
      console.log('Switch boolean value:', booleanValue)

      // Set the value using the same logic as setValue but with more debugging
      const pathArray = path.split('.')
      const lastKey = pathArray.pop()
      const parentPath = pathArray.join('.')

      if (pathArray.length > 0) {
        const parent = _.get(this.localBrandingSettings, parentPath)
        if (parent) {
          this.$set(parent, lastKey, booleanValue)
        } else {
          // Create the parent object if it doesn't exist
          _.set(this.localBrandingSettings, parentPath, {})
          this.$set(
            _.get(this.localBrandingSettings, parentPath),
            lastKey,
            booleanValue
          )
        }
      } else {
        this.$set(this.localBrandingSettings, lastKey, booleanValue)
      }

      // Increment version to trigger reactivity
      this.settingsVersion++

      console.log('After handleSwitchChange:', {
        path,
        newValue: _.get(this.localBrandingSettings, path),
        settingsVersion: this.settingsVersion,
      })
    },
  },
  watch: {
    isGradientEnabled: {
      handler(newVal, oldVal) {
        console.log('isGradientEnabled changed:', {
          oldVal,
          newVal,
          section: this.section,
        })
      },
      immediate: true,
    },
    localBrandingSettings: {
      handler(newVal, oldVal) {
        console.log('localBrandingSettings changed:', {
          oldVal: oldVal ? 'exists' : 'null',
          newVal: newVal ? 'exists' : 'null',
          section: this.section,
        })
      },
      deep: true,
    },
  },
  computed: {
    brandingSettingsOriginal() {
      // console.log('brandingSettingsOriginal computed:', {
      //   getBrending: this.getBrending,
      //   brandingStructure: this.brandingStructure,
      // })
      return (
        _.cloneDeep(this.getBrending) || _.cloneDeep(this.brandingStructure)
      )
    },
    brandingSettings() {
      // Use local settings if available, otherwise use the original data
      // Include settingsVersion to ensure reactivity
      this.settingsVersion // This forces the computed to re-evaluate
      if (this.localBrandingSettings) {
        return this.localBrandingSettings
      }
      return this.brandingSettingsOriginal
    },
    // Add a computed property specifically for the gradient state
    isGradientEnabled() {
      const gradientPath = `sectionsGradientBg.${this.section}`
      const value = _.get(this.brandingSettings, gradientPath)
      console.log('isGradientEnabled computed:', { gradientPath, value })
      return Boolean(value)
    },
    activeControls() {
      console.log('activeControls computed - re-evaluating')
      console.log('Current brandingSettings:', this.brandingSettings)
      console.log('Current section:', this.section)
      console.log('Current sectionName:', this.sectionName)
      console.log('isGradientEnabled:', this.isGradientEnabled)

      const result = this.controls
        .map((control) => {
          const props = { ...control.props }
          if (control.placeholder) {
            props.placeholder =
              typeof control.placeholder === 'function'
                ? control.placeholder(this)
                : control.placeholder
          }
          let text = control.text
          if (text && typeof text === 'function') {
            text = text(this)
          }
          return {
            ...control,
            props,
            text,
          }
        })
        .filter((control) => {
          if (!control.showIf || !control.showIf.includes(this.sectionName)) {
            return false
          }

          // Always show el-switch component (no condition filtering)
          if (control.component === 'el-switch') {
            return true
          }

          if (control.hasOwnProperty('condition')) {
            // Use the computed gradient state instead of calling getValue
            if (control.props.label === 'Background Color') {
              const conditionResult = !this.isGradientEnabled
              console.log(
                `Control condition for ${control.props.label}:`,
                conditionResult
              )
              return conditionResult
            } else if (
              control.props.label === 'Background First Color' ||
              control.props.label === 'Background Second Color'
            ) {
              const conditionResult = this.isGradientEnabled
              console.log(
                `Control condition for ${control.props.label}:`,
                conditionResult
              )
              return conditionResult
            }
            const conditionResult =
              typeof control.condition === 'function'
                ? control.condition(this)
                : control.condition
            console.log(
              `Control condition for ${control.props.label}:`,
              conditionResult
            )
            return conditionResult
          }
          return true
        })

      console.log(
        'activeControls result:',
        result.map((c) => c.props.label || c.component)
      )
      return result
    },
    windowWidth() {
      return this.$store.getters.GET_WINDOW_WIDTH
    },

    // Default About title shown as the input placeholder, mirroring the trust
    // page fallback ("About" / "About + name") so the user sees what they get
    // when leaving the field empty.
    aboutCompanyDefaultTitle() {
      const settings = (this.$store.getters.GET_TRUST_CENTER_DB || []).find(
        (item) => item.type === 'trustCenterSettings'
      )
      const trustCenterName = settings?.trustCenterName || ''
      return trustCenterName ? `About ${trustCenterName}` : 'About'
    },

    getPosition() {
      return {
        top: this.top,
        left: this.left,
        right: this.right,
        bottom: this.bottom,
      }
    },
  },
  components: {
    Hr,
    FontPicker,
    ColorPicker: () =>
      import(
        /* webpackChunkName: 'ColorPicker' */ '@/components/branding/ColorPicker.vue'
      ),
    PlaceHolderInput: () =>
      import(
        /* webpackChunkName: 'PlaceHolderInput' */ '@/components/branding/PlaceHolderInput.vue'
      ),
    FontSize: () =>
      import(
        /* webpackChunkName: 'FontSize' */ '@/components/branding/FontSize.vue'
      ),
    FontWeight: () =>
      import(
        /* webpackChunkName: 'FontWeight' */ '@/components/branding/FontWeight.vue'
      ),
    ButtonsShape: () =>
      import(
        /* webpackChunkName: 'ButtonsShape' */ '@/components/branding/ButtonsShape.vue'
      ),
    LogoPicker: () =>
      import(
        /* webpackChunkName: 'LogoPicker' */ '@/components/branding/LogoPicker.vue'
      ),
    TextFontPicker: () =>
      import(
        /* webpackChunkName: 'TextFontPicker' */ '@/components/branding/TextFontPicker.vue'
      ),
    AlignmentSelect: () =>
      import(
        /* webpackChunkName: 'AlignmentSelect' */ '@/components/branding/AlignmentSelect.vue'
      ),
  },
}
